import { onUnmounted, ref } from "@vue/composition-api";

export default function useBlobUrl() {
  const blobUrls = ref<string[]>([]);

  const getBlobUrl = (file: File) => {
    const url = URL.createObjectURL(file);
    blobUrls.value.push(url);
    return url;
  };

  const revokeBlobs = () => {
    blobUrls.value.forEach(i => URL.revokeObjectURL(i));
    blobUrls.value = [];
  };

  const revokeBlob = (url: string) => {
    URL.revokeObjectURL(url);
    blobUrls.value = blobUrls.value.filter(i => i !== url);
  };

  onUnmounted(revokeBlobs);

  return {
    getBlobUrl,
    revokeBlob,
    revokeBlobs,
  };
}
